import { extractApiErrorMessage, isErrorResponse } from '@cartwheel/api'
import { Announcement, AnnouncementType } from '../announcement'

const NETWORK_STATUS_UNKNOWN = 'Insurance network status unknown'

interface SyncErrorsBannerProps {
  errors: string[]
}

export function SyncErrorsBanner({ errors }: SyncErrorsBannerProps) {
  const networkStatusUnknown = errors.includes(NETWORK_STATUS_UNKNOWN)
  return (
    <>
      <div className="mt-4">
        {networkStatusUnknown ? (
          <Announcement
            type={AnnouncementType.Warning}
            title="Insurance network status not found"
            message={
              <p className="text-md text-charcoal-50">
                Payer not recognized (no network status). Please contact RCM lead to add payer in
                Active Admin.
              </p>
            }
          />
        ) : (
          <Announcement
            type={AnnouncementType.Warning}
            title="Sync failed"
            message={
              <ul className="list-disc list-inside ml-4">
                {errors.map((err) => (
                  <li key={err}>{err}</li>
                ))}
              </ul>
            }
          />
        )}
      </div>
      <div className="mt-2 mb-6 text-charcoal-75">
        Please use the "Create estimate" link to enter the details manually
      </div>
    </>
  )
}

// Pull the `detail` strings off an ErrorResponse body; falls back to a single
// generic message for non-ErrorResponse shaped errors.
export function extractSyncErrorDetails(error: unknown): string[] {
  if (isErrorResponse(error)) {
    return error.errors.map((e) => e.detail).filter(Boolean)
  }
  return [extractApiErrorMessage(error, 'Sync failed. Please try again.')]
}
